export default __webpack_public_path__ + "static/media/epid.103a357c.png";